export default __webpack_public_path__ + "static/media/card3-1920x1080Tiny.d900408a.png";